/**
 * Central navigation config: the neo-tree file structure, buffer names,
 * and their routes. Single source of truth for sidebar + buffer line.
 */

export const NAV_TREE = [
  { name: "about.md", buffer: "about.md", route: "/about" },
  {
    name: "projects/",
    buffer: "projects/",
    route: "/projects",
    children: [
      {
        name: "phaze.md",
        buffer: "projects/phaze.md",
        route: "/projects/phaze",
      },
      { name: "jish.md", buffer: "projects/jish.md", route: "/projects/jish" },
      {
        name: "tanban.md",
        buffer: "projects/tanban.md",
        route: "/projects/tanban",
      },
      {
        name: "bruhdle.md",
        buffer: "projects/bruhdle.md",
        route: "/projects/bruhdle",
      },
      {
        name: "trick.md",
        buffer: "projects/trick.md",
        route: "/projects/trick",
      },
    ],
  },
  {
    name: "experience/",
    buffer: "experience/",
    route: "/experience",
    children: [
      {
        name: "jostle.md",
        buffer: "experience/jostle.md",
        route: "/experience/jostle",
      },
    ],
  },
  { name: "resume.md", buffer: "resume.md", route: "/resume" },
  { name: "contact.md", buffer: "contact.md", route: "/contact" },
];

const findNode = (nodes, pred) => {
  for (const node of nodes) {
    if (pred(node)) return node;
    if (node.children) {
      const found = findNode(node.children, pred);
      if (found) return found;
    }
  }
  return null;
};

/** Given a buffer name like "projects/deploy-cli.md", return its route. */
export const getBufferRoute = (buffer) => {
  const node = findNode(NAV_TREE, (n) => n.buffer === buffer);
  return node ? node.route : "/";
};

/** Given a route like "/about", return its buffer name. */
export const getRouteBuffer = (route) => {
  const node = findNode(NAV_TREE, (n) => n.route === route);
  return node ? node.buffer : "dashboard.md";
};
